import SliderArrow from './sliderArrow.svg';

import DropdownArrowIcon from './DropdownArrowIcon/DropdownArrowIcon';
import CollapseExpandIcon from './DropdownArrowIcon/CollapseExpandIcon/CollapseExpandIcon';
import AccordionArrowIcon from './AccordionArrowIcon/AccordionArrowIcon';

export const buttonIcons: ButtonIconsInterface = {
	sliderarrow: SliderArrow,
	collapaseexpand: CollapseExpandIcon,
	dropdownarrow: DropdownArrowIcon,
	accordionarrowicon: AccordionArrowIcon,
};

export interface ButtonIconsInterface {
	sliderarrow: React.FC<React.SVGProps<SVGSVGElement>>;
	collapaseexpand: React.FC<React.SVGProps<SVGSVGElement>>;
	dropdownarrow: React.FC<React.SVGProps<SVGSVGElement>>;
	accordionarrowicon: React.FC<React.SVGProps<SVGSVGElement>>;
}
